import { utils } from '@seedplanner/shared-utils';
import type React from 'react';
import type { BlendData, Props as CropOrBlendToUseFormProps } from '../order/NewCropOrBlendToUseForm';

export function getLongestGrowTimePlusBufferFromInputForms(
  cropOrBlendForms: React.ReactElement<CropOrBlendToUseFormProps>[],
) {
  const cropGrowTimes = cropOrBlendForms.map((form) => {
    if (form.props.values.cropOrBlendSelected == null) {
      return Number.NEGATIVE_INFINITY;
    }
    if (form.props.values.cropOrBlendSelected.type === 'blend') {
      return Number.NEGATIVE_INFINITY;
    }
    return (
      form.props.values.cropOrBlendSelected.total_grow_time + form.props.values.cropOrBlendSelected.harvest_buffer_time
    );
  });
  const blends: BlendData[] = cropOrBlendForms
    .map((form) => (form.props.values.cropOrBlendSelected == null ? undefined : form.props.values.cropOrBlendSelected))
    .filter(utils.notNull)
    .filter((form) => form.type === 'blend');
  const blendCropGrowTimes = blends.flatMap((n) => {
    return (
      n.crops.edges.map((edge) => {
        if (edge.node.crop == null) {
          return Number.NEGATIVE_INFINITY;
        }

        return edge.node.crop.total_grow_time + edge.node.crop.harvest_buffer_time;
      }) ?? []
    );
  });

  return Math.max(...cropGrowTimes, ...blendCropGrowTimes);
}
